import { lazy, type ReactNode } from 'react'
import { isTokenAuthMode, useMockAuth } from './auth-mode'
import { MockAuthProvider } from './MockAuthProvider'
import { TokenAuthProvider } from './TokenAuthProvider'

const MsalAuthProvider = lazy(() =>
  import('./MsalAuthProvider').then((module) => ({ default: module.MsalAuthProvider })),
)

interface AuthProviderProps {
  children: ReactNode
}

export function AuthProvider({ children }: AuthProviderProps) {
  if (useMockAuth) {
    return <MockAuthProvider>{children}</MockAuthProvider>
  }

  if (isTokenAuthMode) {
    return <TokenAuthProvider>{children}</TokenAuthProvider>
  }

  return <MsalAuthProvider>{children}</MsalAuthProvider>
}
